import { get, downloadFile, uploadFile } from '@/http/axios';

/**
 * 基础数据维护
 */

/**
 * 获取列表
 * @param {*} params
 * @returns
 */
export function getDataBaseList(params) {
  return get({
    url: '/tsp-collect-data/dataBase/list',
    params,
    hasLoading: true
  });
}

/**
 * 获取详情
 * @param {*} params
 * @type 0:获取CAN矩阵详情，1:获取故障字典详情
 */
export function getDetail(type, params) {
  return get({
    url: type === 0 ? '/tsp-collect-data/dataBase/canDetail' : '/tsp-collect-data/dataBase/FaultDetail',
    params,
    hasLoading: true
  });
}

/**
 * 导入
 * @param {*} params
 * @returns
 */
export function dataBaseAdd(data) {
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  });
  return uploadFile({
    url: '/tsp-collect-data/dataBase/add',
    data: formData,
    hasLoading: true
  });
}

/**
 * CAN矩阵模板下载
 * @param {*} params
 * @returns
 */
export function dataBaseCanDownload(params) {
  return downloadFile({
    url: '/tsp-collect-data/dataBase/canDownload',
    params,
    hasLoading: true
  });
}

/**
 * 数据字典模板下载
 * @param {*} params
 * @returns
 */
export function dataBaseFaultDownload(params) {
  return downloadFile({
    url: '/tsp-collect-data/dataBase/faultDownload',
    params,
    hasLoading: true
  });
}

/**
 * 故障字典导出
 * @param {*} params
 * @returns
 */
export function faultExportList(params) {
  return get({
    url: '/tsp-collect-data/dataBase/faultExportList',
    params,
    hasLoading: true
  });
}

/**
 * CAN矩阵导出
 * @param {*} params
 * @returns
 */
export function canExportList(params) {
  return get({
    url: '/tsp-collect-data/dataBase/canExportList',
    params,
    hasLoading: true
  });
}
